import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import api from '../../../utils/api';
import { apiSuccess } from '../../../utils/utils';
import styled from 'styled-components';
import Jargon from '../../../models/Jargon';
import { ActionButton,CancelButton } from '../common/AdminButtons';
import { Form, Input, Select, FormGroup, ButtonGroup, TextArea, CheckboxWithLabel } from '../common/AdminForm';
import { ErrorMessage } from '../common/AdminMessages';

const FormContainer = styled.div`
    padding: 1.5rem;
    background-color: #f9f9f9;
    border-radius: 8px;
`;

// Props interface for the combined JargonForm component
interface JargonFormProps {
    initialJargon?: Jargon; // If provided, indicates edit mode; otherwise, add mode.
    onSuccess: () => void;
    onCancel: () => void;
}

const JargonForm: React.FC<JargonFormProps> = ({ initialJargon, onSuccess, onCancel }) => {
    const [formData, setFormData] = useState<Jargon>(
        initialJargon || {
            id: 0,
            name: '',
            publicDisplay: false,
            sequence: 0,
            description: ''
        }
    );
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: checked
        }));
    };

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        let response;
        if(initialJargon)
        {
            response = await api.put<Jargon>(`/halo/jargons/${initialJargon.id}`,formData);
        }
        else{
            response = await api.post<Jargon>(`/halo/jargons/`,formData);
        }
        if(apiSuccess(response))
        {
            onSuccess();
        } 
        else {
            setErrorMessage(`HTTP ${response.status}: ${response.statusText}`);
            console.log(`Received HTTP ${response.status}: ${response.statusText}`);
        }
    };

    return (
        <FormContainer>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <Form onSubmit={handleSubmit}>
                <label htmlFor="name">Name</label>
                <Input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                />

                <label htmlFor="description">Description</label>
                <TextArea
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}                    
                />

                <label htmlFor="sequence">Sequence</label>
                <Input
                    type="number"
                    name="sequence"
                    value={formData.sequence}
                    onChange={handleInputChange}
                />
            
                <CheckboxWithLabel >
                <Input
                    type="checkbox"
                    name="publicDisplay"
                    checked={formData.publicDisplay}
                    onChange={handleCheckboxChange}
                /> Publicly Visible
                </CheckboxWithLabel>


                <ButtonGroup>
                    <ActionButton type="submit">
                        {initialJargon ? 'Update Jargon' : 'Add Jargon'}
                    </ActionButton>
                    <CancelButton 
                        type="button" 
                        onClick={onCancel}
                    >
                        Cancel
                    </CancelButton>
                </ButtonGroup>
            </Form>
        </FormContainer>
    );
};

export default JargonForm;
